import { render, staticRenderFns } from "./ViewSitePage.vue?vue&type=template&id=f12635ca&scoped=true&"
import script from "./ViewSitePage.vue?vue&type=script&lang=js&"
export * from "./ViewSitePage.vue?vue&type=script&lang=js&"
import style0 from "./ViewSitePage.vue?vue&type=style&index=0&id=f12635ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12635ca",
  null
  
)

export default component.exports